import { BaseModel } from "../Generics/BaseModel"
import { CatalogProductEntity } from "../ProductsAndCatalogItems/CatalogProductEntity"
import { ComboItemReference } from "./ComboItemReference"

export class ComboEntity extends BaseModel {
  id: number
  
  productId: number

  catalogProductEntity: CatalogProductEntity

  items: ComboItemReference[]

  constructor(data: Partial<ComboEntity> = {}) {
    super()

    const sourceData = data as any

    const productEntityCatalogProduct = sourceData.productEntity?.catalogProductEntity

    const productEntityCategoryName = (productEntityCatalogProduct?.category?.name ?? "").trim().toLowerCase()

    const isComboProductEntity = productEntityCategoryName === "combos"

    this.id = sourceData.id ?? -1

    this.productId = sourceData.productId ?? sourceData.productEntity?.id ?? -1

    this.catalogProductEntity = new CatalogProductEntity(sourceData.catalogProductEntity ?? (isComboProductEntity
      ? productEntityCatalogProduct
      : undefined))

    this.items = (sourceData.items ?? sourceData.comboItems ?? []).map((e: ComboItemReference) => new ComboItemReference(e))
  }
}
